import { SvgIcon, SvgIconProps } from '@mui/material'
import React, { FC } from 'react'

export const ClipboardIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="48"
      height="56"
      viewBox="0 0 48 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37.3334 1.33325V6.66658M24 1.33325V6.66658M10.6667 1.33325V6.66658M13.3334 35.9999H24M13.3334 22.6666H34.6667M1.33337 22.6666C1.33337 13.8666 1.33337 9.46658 4.06671 6.73325C6.80004 3.99992 11.2 3.99992 20 3.99992H28C36.8 3.99992 41.2 3.99992 43.9334 6.73325C46.6667 9.46658 46.6667 13.8666 46.6667 22.6666V35.9999C46.6667 44.7999 46.6667 49.1999 43.9334 51.9332C41.2 54.6666 36.8 54.6666 28 54.6666H20C11.2 54.6666 6.80004 54.6666 4.06671 51.9332C1.33337 49.1999 1.33337 44.7999 1.33337 35.9999V22.6666Z"
        stroke="#94A3B8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  )
}
